import DateTimeFormatCache from './dateTimeFormatCache';
import {convertDashesToSlashes} from './dateHelper';

const arrivalDateFormatterCache = new DateTimeFormatCache({
    year: 'numeric',
    month: 'short'
});
const createdDateFormatterCache = new DateTimeFormatCache({
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});

const getFormattedReviewDate = (isoDate, locale, isCreatedDate) => {
    const formatter = isCreatedDate
        ? createdDateFormatterCache.getFormatter(locale)
        : arrivalDateFormatterCache.getFormatter(locale);
    const relativeDate = new Date(convertDashesToSlashes(isoDate.split('T')[0]));
    const formattedDate = formatter.format(relativeDate);
    return formattedDate;
};

export default getFormattedReviewDate;

export {getFormattedReviewDate};
